import React, { useState } from "react";
import "./ProductCard.css";
import { Link } from "react-router-dom";

const ProductCard = ({ product }) => {
  const { name, category, price, images, stock, description } = product;
  const [loading, setLoading] = useState(false);

  // Calculate total stock
  const totalStock = stock.reduce(
    (acc, item) => acc + parseInt(item.quantity, 10),
    0
  );

  return (
    <>
      <div className="product-card" key={`${product._id}jhdjhgs`}>
            <div className="product-image">
              <img
                src={`https://riymay.com/assets/${product.images[0]?.url}`}
                loading={<img src="https://cdn.pixabay.com/animation/2024/04/02/07/57/07-57-40-974_512.gif" />}
                alt={product.images[0]?.altText || product.name}
              />
            </div>
            <div className="product-details">
              <p className="product-card-name">
                {product.name.length > 25
                  ? `${product.name.substring(0, 25)}...`
                  : product.name}
              </p>
              <div className="product-overlay">
                 <Link className="product-card-container" key={product._id} to={`/product/${product._id}`}><button className="quick-shop-btn">Quick Shop</button> </Link>
                <div className="product-info">
                  <div className="product-price">&#8377;{product.price}</div>
                  <div className="sizes-product">
                    {product.stock.map((stockItem) => (
                      <button
                        key={stockItem._id}
                        className="size-button-product"
                        disabled={stockItem.quantity <= 0}
                      >
                        {stockItem.size}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
    </>
  );
};

export default ProductCard;
